// @flow
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    backgroundColor: 'inherit',
    height: '100vh',
    width: '100%',
  },
}));

export default useStyles;
